module.exports = __webpack_public_path__ + "static/img/200219.df5a2861.png";